export async function fetchProfileQuestions(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/questions/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function fetchMilestoneInstructions(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API +
      `/v1/api/milestone-instruction?milestoneId=${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function fetchData(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/fetch-data/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function downloadChildFile(id, question_id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/fetch-child-file/${id}_${question_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function downloadParentFile(milestoneId, id, question_id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API +
      `/v1/api/fetch-parent-file/${milestoneId}/${id}_${question_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function downloadUploadedFile(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/download-uploaded-file/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}


// export async function updateUploadedFileStatus(id) {
//   const token = localStorage.getItem("token");
//   const rawResponse = await fetch(
//     process.env.REACT_APP_API + `/v1/api/update-uploaded-file-status/${id}`,
//     {
//       method: "PUT",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
//   const content = await rawResponse.json();
//   if (rawResponse.status === 200) {
//     return { body: content.body, success: true, message: "" };
//   } else {
//     return { body: [], success: false, message: content.message };
//   }
// }

export async function insertBasicDetails(formValues, milestoneId) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/save-data/${milestoneId}`;
  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: formValues,
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return {
      body: [],
      success: false,
      message: content.body != null ? content.body : content.message,
    };
  }
}

export async function insertChildDetails(formValues, id) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/save-child-data/${id}/`;

  try {
    const rawResponse = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formValues,
    });

    const content = await rawResponse.json();

    if (rawResponse.status === 200) {
      return { body: content.body, success: true, message: "" };
    } else {
      let errorMessage = content.body;
      return { body: [], success: false, message: errorMessage };
    }
  } catch (error) {
    console.error("Error:", error);
    return {
      body: [],
      success: false,
      message: "Bad Request.",
    };
  }
}

export async function editMultiChildDetails(formValues, id, multiChildId) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/save-child-data/${id}/?childId=${multiChildId}`;
  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: formValues,
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function deleteMultiChildDetails(id, milestoneId) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/delete-child/${milestoneId}/${id}`;
  const rawResponse = await fetch(url, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function insertScrutinyData(formValues, milestoneId) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/save/scrutiny-data/${milestoneId}`;
  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: formValues,
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: content.message };
  } else {
    return {
      body: [],
      success: false,
      message: content.body != null ? content.body : content.message,
    };
  }
}
